const BASE = process.env.REACT_APP_API_URL || 'https://portfoliotracker-production-5eb2.up.railway.app';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) { const err = new Error(data.message || 'Request failed'); err.status = res.status; throw err; }
  return data;
}

export const authApi = {
  register: (email, password) =>
    request('/api/auth/register', { method: 'POST', body: JSON.stringify({ email, password }) }),

  login: (email, password) =>
    request('/api/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),

  refresh: (refreshToken) =>
    request('/api/auth/refresh', { method: 'POST', body: JSON.stringify({ refreshToken }) }),

  logout: (accessToken) =>
    request('/api/auth/logout', {
      method: 'POST',
      headers: { Authorization: `Bearer ${accessToken}` },
    }),

  me: (accessToken) =>
    request('/api/auth/me', {
      headers: { Authorization: `Bearer ${accessToken}` },
    }),

  registerInvite: (email) =>
    request('/api/auth/register-invite', { method: 'POST', body: JSON.stringify({ email }) }),

  completeRegistration: (token, password) =>
    request('/api/auth/complete-registration', { method: 'POST', body: JSON.stringify({ token, password }) }),

  forgotPassword: (email) =>
    request('/api/auth/forgot-password', { method: 'POST', body: JSON.stringify({ email }) }),

  resetPassword: (token, newPassword) =>
    request('/api/auth/reset-password', { method: 'POST', body: JSON.stringify({ token, newPassword }) }),

  changePassword: (accessToken, currentPassword, newPassword) =>
    request('/api/auth/change-password', {
      method: 'POST',
      headers: { Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ currentPassword, newPassword }),
    }),

  /**
   * GDPR Article 20 — download every piece of personal data we hold as JSON.
   * Triggers a browser download. Returns the filename used.
   */
  async dataExport(accessToken) {
    const res = await fetch(`${BASE}/api/auth/data-export`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!res.ok) {
      const text = await res.text();
      let msg = 'Data export failed';
      try { msg = JSON.parse(text).message || msg; } catch {}
      const err = new Error(msg); err.status = res.status; throw err;
    }

    let filename = `inverow-export-${new Date().toISOString().replace(/[:.]/g, '-')}.json`;
    const cd = res.headers.get('Content-Disposition');
    if (cd) {
      const m = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
      if (m) filename = decodeURIComponent(m[1]);
    }

    const blob = await res.blob();
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    URL.revokeObjectURL(url);
    return filename;
  },
};
